<template>
  <div class="qa-container container">
    <h1>購物流程</h1>
    <section>
      <h2>訂購流程說明</h2>
      <div class="text-box">
        <div class="black">
          1.&nbsp;選擇商品&nbsp;>&nbsp;點選尺寸、顏色、數量
          <span class="main"> 【&nbsp;加入購物車&nbsp;】 </span>
          ，選購完畢後點選購物車
          <span class="main"> 【&nbsp;訂單結帳&nbsp;】 </span>
          ，前往結帳。
        </div>
      </div>
      <div class="text-box">
        <div class="black">
          2.&nbsp;確認購買清單，選擇送貨地點、送貨方式及付款方式後，確認購物車中的商品、顏色尺寸、金額是否正確無誤。
        </div>
      </div>
      <div class="text-box">
        <div class="black">
          3.&nbsp;點選
          <span class="main"> 【&nbsp;前往結帳&nbsp;】 </span>
          填寫顧客資料&nbsp;/&nbsp;送貨資料&nbsp;/&nbsp;付款資料，提交訂單，下一步會顯示訂單號碼，才算完成訂購唷。
        </div>
      </div>
    </section>
    <section>
      <h2>電話訂購說明</h2>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;電話訂購說明 Order by phone</div>
        為提供更便利的購物選擇，特別為國內買家提供電話訂購服務，服務專線『&nbsp;+886-980-353064&nbsp;』
        客服將協助您代理線上購物，祝您購物愉快。
      </div>
      <div class="text-box">
        <div class="black"><i class="fas fa-heart"></i>&nbsp;訂購流程說明</div>
        <div class="part">
          1.&nbsp;
          來電前請先於森女部落官網頁面選定您所需要的商品貨號、顏色尺寸，以及欲選購的數量，以減少等候的時間。
        </div>
        <div class="part">
          2.&nbsp;
          如您已註冊為會員，請告知客服人員您的手機號碼；如您尚未註冊為會員，客服將協助您加入會員，需提供姓名、手機號碼、聯絡信箱、出生
          日期、居住地址，客服將為您建立資料，方可協助訂購。
        </div>
        <div class="part">
          3.&nbsp;
          確認訂單內容後，需再提供收件人相關資訊，收件人姓名、收件人電話、付款方式、寄送方式、其他備註事項。
        </div>
        <div class="part">※&nbsp;因個資問題，電話訂購不提供線上刷卡服務唷。</div>
        4.&nbsp;與客服人員完成核對，即完成訂購，若想確認訂單可登入官網會員中心查詢。
      </div>
    </section>
    <section>
      <h2>預購商品說明</h2>
      <div class="text-box">
        <div class="black">
          因每個商家的運作模式都不太相同，不論您是否為網路購物的新使用者，為避免誤會或不必要的糾紛，都請看一下說明喔!
        </div>
      </div>
      <div class="text-box">
        <div class="black">
          1.&nbsp;什麼叫做預購?如果你們沒有現貨，賣場上的「&nbsp;商品數量&nbsp;」為什麼打這麼多呢?
        </div>
        Ans&nbsp;:&nbsp;為了能讓北鼻們能順利訂到想要的商品，避免現貨售完、搶不到補貨的困擾
        ，賣場大多商品是以【&nbsp;現貨&nbsp;+&nbsp;預購&nbsp;】的方式進行販售的喔。
      </div>
      <div class="text-box">
        <div class="black">
          2.&nbsp;現貨出貨的順序，是以&nbsp;"&nbsp;訂購順序&nbsp;"&nbsp;嗎?&nbsp;
          還是&nbsp;"&nbsp;匯款先後&nbsp;"&nbsp;順序呢?
        </div>
        Ans&nbsp;:&nbsp;
        現貨出貨的順序是以「完成所有結帳流程&匯款」的先後順序來排的喔～並非按照點選加入購物車順序，因此有可能您是前幾名訂購，但因為較晚才完成結帳或匯款，而遇到現貨已經寄完須等預購追加的情形。
      </div>
      <div class="text-box">
        <div class="black">3.&nbsp;預購商品大約需要等多久呢?</div>
        <div class="part">
          Ans&nbsp;:&nbsp;賣場的現貨若已全數寄完，需等待廠商製作並寄送過來賣場，約&nbsp;7-20&nbsp;個工作天&nbsp;(&nbsp;不含例假日&nbsp;)，
          鞋靴類商品由於製作費時，大約到&nbsp;20&nbsp;個工作天&nbsp;(&nbsp;不含例假日&nbsp;)&nbsp;呦。
        </div>
        <div class="part">
          不過請特別注意，日期算法是從您「實際匯款日」開始的&nbsp;7-20&nbsp;個工作天&nbsp;(&nbsp;不含例假日&nbsp;)，並非「下標日」喔!
        </div>
        因此若您匯款後沒有排到現貨，最晚會在您匯款後的&nbsp;7-20&nbsp;個工作天內收到商品!所以無法等待此商品追加時間的買家，請斟酌下標，以免久候而造成誤會～
      </div>
      <div class="text-box">
        <div class="black">4.&nbsp;如果預購商品超過我匯款日後14天還沒到怎麼辦?</div>
        <div class="part">
          Ans&nbsp;:&nbsp;若因突發狀況&nbsp;(&nbsp;例如&nbsp;:&nbsp;工廠忙不過來，特殊布料須等上游布行訂作，
          遇上海關查驗&nbsp;)，造成商品無法於&nbsp;7-20&nbsp;個工作天&nbsp;(&nbsp;不含例假日&nbsp;)&nbsp;內到貨。
        </div>
        <div class="part">
          購買多件者，Snbl&nbsp;會主動負擔郵資幫您分批寄出&nbsp;(&nbsp;海外訂單不在此內&nbsp;)，先寄出有貨的商品。
        </div>
        只購買單件者，因為沒有辦法分批寄出，要是水水表示不願意繼續等待，都可以選擇換色或是退款處理。
      </div>
      <div class="text-box">
        <div class="black">5.&nbsp;預購商品為什麼會斷貨呢?追加失敗的話要怎麼處理呢?</div>
        <div class="part">
          Ans&nbsp;:&nbsp;由於&nbsp;Snbl&nbsp;跟廠商訂貨時，少數時候會因為上游布行工廠已經不再生產該布料，若沒有布料也沒有辦法製作成品，
          也只能跟&nbsp;Snbl&nbsp;說無法追加，因此才會有所謂的缺布斷貨問題。
        </div>
        <div class="part">
          如有追加失敗的情形，Snbl&nbsp;會請小幫手發送斷貨通知，如已匯款的話，
          可以選擇換色或退款處理。
        </div>
        <div class="part">
          像這樣遇到斷貨的情形，絕不是我們所樂見的，
          Snbl&nbsp;這邊的損失也很大，不過為避免北鼻們的不開心，請先衡量一下，可以接受以上情形再下標喔～
        </div>
        <div class="part">
          如遇商品斷貨，小幫手會使用&nbsp;E-mail&nbsp;與簡訊通知，為了避免打擾甜心們，
          Snbl&nbsp;不會用電話通知斷貨~還請見諒^^
        </div>
        (&nbsp;信件有時會有漏信問題，建議北鼻們可以將森女的系統信加入通訊錄喔&nbsp;)
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/stylesheets/custom/_variable';

.qa-container {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  h1 {
    margin-bottom: 1.5rem;
    text-align: center;
    text-indent: 0.25rem;
    letter-spacing: 0.25em;
    @include font-xl;
  }

  section {
    margin-bottom: 2.5rem;

    h2 {
      margin-bottom: 1rem;
      @include font-lg;
    }

    .text-box {
      color: $gray-600;

      .black {
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: $gray-900;
      }

      .part {
        margin-bottom: 0.5rem;
      }

      .main {
        font-weight: 500;
        color: $color-main;
      }

      &:not(:last-child) {
        margin-bottom: 1rem;
      }

      a {
        color: #337ab7;
      }
    }
  }
}
</style>
